import Tippy, { useSingleton } from "@tippyjs/react";
import { useAtomValue } from "jotai";
import { canv } from "@/canv/global";
import {
    boardInfoAtom,
    headerActiveButtonAtom,
    multiCursorsAtom,
    presentationUID,
} from "@/interface/AppStore";
import { Comments } from "@/interface/HeaderBar/RightBar/Comments";
import { MultiplayerCursors } from "@/interface/HeaderBar/RightBar/MultiplayerCursors";
import { Presentation } from "@/interface/HeaderBar/RightBar/Presentation";
import { ShareButton } from "@/interface/HeaderBar/RightBar/ShareButton";
import { Timer } from "@/interface/HeaderBar/RightBar/Timer/Timer";
import { UsersList } from "@/interface/HeaderBar/RightBar/UsersList";
import styles from "./RightBar.module.scss";
import { Vote } from "./Vote";

type RightBarProps = {
    className?: string;
};

export const RightBar = ({ className }: RightBarProps) => {
    const [source, target] = useSingleton();
    const { disableMultiCursors } = useAtomValue(multiCursorsAtom);
    const { boardAccessToken, boardMode } = useAtomValue(boardInfoAtom);
    const activeButtonName = useAtomValue(headerActiveButtonAtom);
    const UID = useAtomValue(presentationUID);

    const showTimer = !canv.isBoardModeView();
    const showShareButton =
        boardAccessToken === "" && (boardMode === "edit" || boardMode === "owner");
    const showVote = canv.isBoardModeEditOrOwner() && canv.isTeamMember();
    return (
        <div className={className}>
            <Tippy singleton={source} />
            <div className={styles.actions}>
                {showTimer && (
                    <Timer
                        className={styles.timerBtn}
                        singletoneTarget={target}
                        isActive={activeButtonName === "timer"}
                    />
                )}
                <Presentation
                    isActive={activeButtonName === "presentation"}
                    activePresentationUID={UID}
                    className={styles.presentationBtn}
                    singletoneTarget={target}
                />
                {showVote && <Vote className={styles.voteBtn} singletoneTarget={target} />}
                {/* TODO: comments */}
                <Comments
                    className={styles.commentsBtn}
                    singletoneTarget={target}
                    isActive={activeButtonName === "comments"}
                />

                <MultiplayerCursors
                    className={styles.cursorsBtn}
                    singletoneTarget={target}
                    disableMultiCursors={disableMultiCursors}
                />

                <UsersList />
            </div>
            {showShareButton && <ShareButton className={styles.shareBtn} />}
        </div>
    );
};
